module.exports = __webpack_public_path__ + "img/calendar.6b17a88c.svg";